<template>
  <el-card>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-input
          size="small"
          style="width: 20%"
          v-model="classifyKeyword"
          placeholder="关键词搜索"
        ></el-input>
        <el-button size="small" type="primary">查询</el-button>
      </el-col>
      <el-col :span="24">
        <div class="classify-add-body">
          <div class="classify-series" @click="handleChangeTabs">
            <span
              id="0"
              :class="
                tabsIndex == '0' ? 'classify-item active' : 'classify-item'
              "
              >精品小课</span
            >
            <span
              id="1"
              :class="
                tabsIndex == '1' ? 'classify-item active' : 'classify-item'
              "
              >品牌课程</span
            >
            <span
              id="2"
              :class="
                tabsIndex == '2' ? 'classify-item active' : 'classify-item'
              "
              >热门职业</span
            >
            <span
              id="3"
              :class="
                tabsIndex == '3' ? 'classify-item active' : 'classify-item'
              "
            >免费试听</span
            >
            <!-- <span id="3" :class="tabsIndex == '3' ? 'classify-item active' : 'classify-item'">热门证书</span> -->
          </div>
          <div>
            <el-button
              @click="addClassify(0)"
              size="small"
              type="primary"
              icon="el-icon-plus"
              >分类</el-button
            >
          </div>
          <b class="under-line"></b>
        </div>
      </el-col>
    </el-row>

    <el-tree
      @node-drop="handleDrop"
      draggable
      :allow-drop="allowDrop"
      :data="treeData"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
      class="tree"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          {{ data.name }}
          <el-button
            @click="
              (classifyName = data.name), (classifyId = data.id), addClassify(1)
            "
            v-if="data.level == 1"
            icon="el-icon-plus"
            type="text"
            size="mini"
          ></el-button>
        </span>
        <span>
          <el-button
            @click="openUpdateClassifyNameDialog(data)"
            icon="el-icon-edit-outline"
            type="text"
            size="mini"
          ></el-button>
          <el-switch
            @change="handleTreeState(data.id)"
            v-model="data.showState"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </span>
      </span>
    </el-tree>

    <el-dialog
      title="修改分类名称"
      :visible.sync="updateClassifyNameVisible"
      width="30%"
      :before-close="handleClosed"
    >
      <el-form ref="form" :model="classifyForm" label-width="80px">
        <el-form-item label="分类名称">
          <el-input clearable v-model="classifyForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateClassifyNameVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateClassifyName">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="添加分类"
      :visible.sync="addVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <p v-if="level == 0" style="margin: 5px 0 0 0">{{ tabsName }}</p>
          <p v-else style="margin: 5px 0 0 0">{{ classifyName }}</p>
        </el-col>
        <el-col :span="20">
          <div
            v-for="(inputItem, index) in classifyFormArr"
            :key="inputItem.id"
          >
            <el-input
              size="small"
              style="width: 50%"
              v-model="inputItem.name"
              placeholder="分类名称"
            ></el-input>
            <!-- <el-input size="small" style="width:50%;" v-model="classifyKeyword" placeholder="分类名称"></el-input> -->
            <i
              v-show="!inputItem.isFirst"
              @click="up(index)"
              class="sort el-icon-sort-up"
            ></i>
            <i
              v-show="!inputItem.isEnd"
              @click="down(index)"
              class="sort el-icon-sort-down"
            ></i>
          </div>
          <div class="get-more" @click="addClassifyItem">更多分类</div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      treeData: [],
      initData: [],
      tabsName: "精品小课",
      tabsIndex: "0",
      classifyKeyword: "",

      addVisible: false,
      classifyFormArr: [
        { name: "", sort: 0, id: 0, isEnd: false, isFirst: true },
      ],
      classifyId: "", // 一级id
      updateClassifyNameVisible: false,
      classifyForm: {
        name: "",
      },
      level: 1,
      classifyName: "",
    };
  },
  methods: {
      handleDrop(draggingNode, dropNode, dropType, ev) {
        let pid = this.initData[this.tabsIndex].id
        this.treeData.forEach((el,index)=>{
          el.sort = index + 1
          el.level = 1
          el.pid = pid
          if(el.children.length > 0){
            const child = el.children
            child.forEach((item,i)=>{
              item.sort = i + 1
              item.level = 2
              item.pid = el.id
            })
          }
        })
        // 调接口
        this.api.classifyManage.sortClassificationManagement(this.treeData)
        console.log('tree drop: ',draggingNode, dropNode, this.treeData);
      },
    allowDrop(draggingNode, dropNode, type) {
      let a = draggingNode.data.children.length > 0
      let b = dropNode.level === 2 && type === 'inner'
      if(a || b) return false;
      else return true;
    },

    getClassificationManagementTree() {
      this.api.classifyManage
        .getClassificationManagementTree({ keyword: this.classifyKeyword })
        .then((res) => {
          console.log(res);
          this.initData = res.data;

          this.treeData = this.initData[parseInt(this.tabsIndex)].children;
          // this.insertKeyInArrayObject(this.treeData,'label')
          console.log(
            this.treeData,
            this.initData[parseInt(this.tabsIndex)],
            35434
          );
        });
    },
    insertKeyInArrayObject(arr, k) {
      if (arr.length > 0) {
        arr.forEach((el) => {
          this.$set(el, k, el.name);
          this.insertKeyInArrayObject(el.children, k);
        });
      } else return;
    },
    // state
    handleTreeState(id) {
      this.api.classifyManage
        .disableClassificationManagement(id)
        .then((res) => {
          console.log(res);
          this.getClassificationManagementTree();
        });
    },

    // 修改name
    openUpdateClassifyNameDialog(item) {
      this.updateClassifyNameVisible = true;
      this.classifyForm = JSON.parse(JSON.stringify(item));
      console.log(this.classifyForm);
    },
    updateClassifyName() {
      this.api.classifyManage
        .updateClassificationManagement({ ...this.classifyForm })
        .then((res) => {
          console.log(res);
          this.updateClassifyNameVisible = false;
          this.getClassificationManagementTree();
        });
    },
    handleClosed() {
      this.updateClassifyNameVisible = false;
    },

    handleChangeTabs(e) {
      this.tabsIndex = e.target.id;
      this.tabsName = e.target.textContent;
      if(this.initData[this.tabsIndex]){
        this.treeData = this.initData[this.tabsIndex].children;
      }else {
        this.treeData = [];
      }
      // this.insertKeyInArrayObject(this.treeData,'label')
      console.log(
        this.treeData,
        this.initData,
        35434,
        this.initData[this.tabsIndex],
        "change"
      );
    },

    // 添加name
    addClassify(level) {
      this.addVisible = true;
      this.level = level;
      this.classifyFormArr = [
        { value: "", sort: 0, id: 0, isEnd: false, isFirst: true },
      ];
    },
    handleClose() {
      this.addVisible = false;
    },
    addClassifyItem() {
      this.classifyFormArr.forEach((el) => {
        this.$set(el, "isEnd", false);
      });
      const len = this.classifyFormArr.length;

      this.classifyFormArr.push({
        name: "",
        sort: len,
        id: len,
        isEnd: true,
        isFirst: false,
      });
      console.log(len, this.classifyFormArr, 33);
    },
    up(index) {
      console.log(234, "up", index);
      let currentItem = this.classifyFormArr[index];
      let prevItem = this.classifyFormArr[index - 1];
      this.classifyFormArr[index] = prevItem;
      this.classifyFormArr[index - 1] = currentItem;
      if (prevItem.isFirst) {
        prevItem.isFirst = false;
        currentItem.isFirst = true;
      }
      if (currentItem.isEnd) {
        currentItem.isEnd = false;
        prevItem.isEnd = true;
      }
    },
    down(index) {
      console.log(234, "down", index);
      let currentItem = this.classifyFormArr[index];
      let nextItem = this.classifyFormArr[index + 1];
      this.classifyFormArr[index] = nextItem;
      this.classifyFormArr[index + 1] = currentItem;
      if (currentItem.isFirst) {
        currentItem.isFirst = false;
        nextItem.isFirst = true;
      }
      if (nextItem.isEnd) {
        nextItem.isEnd = false;
        currentItem.isEnd = true;
      }
    },

    submit() {
      let params = [];
      let pid = "";
      console.log(this.level, 33);
      if (this.level == 0) {
        pid = this.initData[this.tabsIndex].id;
        this.classifyFormArr.forEach((el, index) => {
          params.push({ level: 1, name: el.name, pid, sort: index + 1 });
        });
      } else {
        pid = this.classifyId;
        this.classifyFormArr.forEach((el, index) => {
          params.push({ level: 2, name: el.name, pid, sort: index + 1 });
        });
      }

      console.log(params);
      this.api.classifyManage
        .addClassificationManagementList(params)
        .then((res) => {
          this.handleClose();
          this.getClassificationManagementTree();
        });
    },
  },
  mounted() {
    this.getClassificationManagementTree();
  },
};
</script>

<style lang="less" scoped>
.tree {
  margin-top: 20px;
  & /deep/ .el-tree-node__content {
    padding: 10px 0;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.classify-add-body {
  padding: 10px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .classify-series {
    .classify-item {
      margin: 0 10px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      &:hover {
        color: #69a4e9;
      }
      &.active {
        position: relative;
        color: #69a4e9;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -17px;
          width: 100%;
          height: 2px;
          background-color: #69a4e9;
          z-index: 10;
        }
      }
    }
  }
  .under-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #dddddd;
  }
}
.sort {
  color: #63abff;
  cursor: pointer;
}
.get-more {
  margin-top: 20px;
  color: #63abff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CommodityClassificationManagement/goodsClassifyManage.vue